require.register("modules/m04s/m04s-activity/page-4/page-4", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page4 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page4;

  
});

